/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import Pad4xTwoToothedBelt from "../../../Assets/Cartesian/profileType/PAD4xTwoToothedbeltAxis.svg";
import Pas4xBallScrewAxis from "../../../Assets/Cartesian/profileType/PAS4xBallscrewAxis.svg";
import Pas4xToothedBeltAxis from "../../../Assets/Cartesian/profileType/PAS4xToothedbeltAxis.svg";
import Tas4xBallScrewLinearTable from "../../../Assets/Cartesian/profileType/TAS4xBallscrewLinearTable.svg";
import MsxIcons from "../../../components/common/Icons/MsxIcons/MsxIcons";
import Spinner from "../../../components/common/Icons/Spinner/Spinner";
import {
  selectCartesianFilters,
  selectCartesianPossibleFiltersValues,
  selectDefaultFilters,
  selectDynamics,
  selectMechanics,
  setCartesianFilters
} from "../../../store/slices/cartesian";
import { syncCartesianFiltersDependencies } from "../../../utils/api/Cartesian/api";
import t from "../../../utils/common/translation/translator";
// import SelectionRange from "../../../components/Inputs/SelectionRange/SelectionRange";
// import MultiRangeSlider from "./MultiRangeSlider";

const productTypeImagesMapping = {
  "PAD4 axis with two toothed belt": Pad4xTwoToothedBelt,
  "PAS4 axis with toothed belt": Pas4xToothedBeltAxis,
  "PAS4 axis with ball screw": Pas4xBallScrewAxis,
  "TAS4 axis with ball screw linear table": Tas4xBallScrewLinearTable
};

const countAppliedFilters = (filters) => {
  let count = 0;
  if (filters.axisFilter?.axisType && filters.axisFilter?.axisType?.length > 0) {
    count += 1;
  }
  if (filters.axisFilter?.driveType && filters.axisFilter?.driveType?.length > 0) {
    count += 1;
  }
  if (filters.axisFilter?.profileDimension && filters.axisFilter?.profileDimension?.length > 0) {
    count += 1;
  }
  if (filters.guideFilter?.guideType && filters.guideFilter?.guideType?.length > 0) {
    count += 1;
  }
  return count;
};

const FiltersButton = ({ filtersOpened, onClick, isLoadingOrFetchingGetAxesCombinations }) => {
  const filters = useSelector(selectCartesianFilters);
  const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);

  useEffect(() => {
    setAppliedFiltersCount(countAppliedFilters(filters));
  }, [filters]);

  return (
    <div
      className="flex items-center cursor-pointer text-center text-lg shadow rounded-full border border-gray-300 w-full py-2 hover:bg-gray-100 transition-all duration-100"
      onClick={onClick}
    >
      <div className="flex-1 flex items-center justify-center space-x-2 mr-5">
        {!isLoadingOrFetchingGetAxesCombinations && <MsxIcons name="action_filter" size="small" />}
        <span className="font-semibold text-gray-700">
          {isLoadingOrFetchingGetAxesCombinations ? "Loading..." : t("cartesian.ui.axis_selection.filters")}
        </span>
        {appliedFiltersCount > 0 && (
          <span className="bg-primary w-5 h-5 text-white rounded-full flex items-center justify-center text-xs font-semibold">
            {appliedFiltersCount}
          </span>
        )}
      </div>
      <MsxIcons
        name="arrow3_down"
        className={`text-gray-500 mx-5 transition-all duration-100 ${filtersOpened ? "transform rotate-180" : ""}`}
        size="small"
      />
    </div>
  );
};

const ProductInfoSection = ({ image, title1, title2, value, handleCheckboxChange, isSelected, disabled }) => {
  const handleClick = () => {
    if (!disabled) {
      handleCheckboxChange({ target: { value, checked: !isSelected } });
    }
  };
  return (
    <div className="flex-1 flex items-center justify-center">
      <div
        className={`flex flex-col items-center justify-center space-y-1 w-fit
          border-2 border-transparent ${
            disabled ? "cursor-not-allowed opacity-50" : "hover:border-primary cursor-pointer"
          }
          rounded-md p-2`}
        onClick={handleClick}
      >
        <img src={image} className="max-h-[50px] mix-blend-multiply" alt={value} />
        <div className="text-center text-xs">
          <div className="font-semibold">{title1}</div>
          <div>{title2}</div>
        </div>
        <input
          key={value + isSelected}
          type="checkbox"
          className={`bg-white checked:bg-secondary rounded-sm border-gray-400 ${
            disabled ? "cursor-not-allowed border-gray-200 bg-gray-100" : "cursor-pointer"
          }`}
          value={value}
          checked={isSelected && !disabled}
          readOnly
          disabled={disabled}
          onClick={(e) => {
            // Prevent the click event from bubbling up to the parent div
            e.stopPropagation();
            if (!disabled) {
              handleCheckboxChange({ target: { value, checked: !isSelected } });
            }
          }}
        />
      </div>
    </div>
  );
};
const AxisTypeSection = ({ filters, dependencies, isLoadingOrFetchingGetAxesCombinations }) => {
  const dispatch = useDispatch();

  const handleCoverStripChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...filters.applicationDataFilter,
      withCoverstrip: isChecked
    };

    dispatch(
      setCartesianFilters({
        ...filters,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleAntistaticBeltChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...filters.applicationDataFilter,
      withAntistaticBelt: isChecked
    };

    const updatedMechanicalDriveFilter = {
      ...filters.mechanicalDriveFilter,
      functionAvailable: isChecked ? ["anti-static toothed belt"] : [null, "standard"]
    };
    dispatch(
      setCartesianFilters({
        ...filters,
        mechanicalDriveFilter: updatedMechanicalDriveFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleIncreasedCorrosionProtectionChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...filters.applicationDataFilter,
      withIncreasedCorrosionProtection: isChecked
    };

    const updatedGuideFilter = {
      ...filters.guideFilter,
      functionAvailable: isChecked ? ["increased corrosion resistance"] : [null, "standard"]
    };
    dispatch(
      setCartesianFilters({
        ...filters,
        guideFilter: updatedGuideFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleDrivenAxisChange = () => {
    const updatedApplicationDataFilter = {
      ...filters.applicationDataFilter,
      withDrivenAxis: true,
      withSupportAxis: false
    };

    const updatedAxisFilter = {
      ...filters.axisFilter,
      functionAvailable: ["driven axis"]
    };
    dispatch(
      setCartesianFilters({
        ...filters,
        axisFilter: updatedAxisFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleSupportAxisChange = () => {
    const updatedApplicationDataFilter = {
      ...filters.applicationDataFilter,
      withDrivenAxis: false,
      withSupportAxis: true
    };

    const updatedAxisFilter = {
      ...filters.axisFilter,
      functionAvailable: ["support axis"]
    };
    dispatch(
      setCartesianFilters({
        ...filters,
        axisFilter: updatedAxisFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  return (
    <div className="flex flex-col space-y-4">
      <span className="font-semibold text-gray-700 mb-2">{t("cartesian.ui.axis_selection.axis_type")}</span>
      <div className="flex">
        <qds-button
          importance={filters?.applicationDataFilter?.withDrivenAxis ? "emphasized" : ""}
          text={t("cartesian.ui.axis_selection.driven_axis")}
          onClick={handleDrivenAxisChange}
        />
        <qds-button
          importance={filters?.applicationDataFilter?.withSupportAxis ? "emphasized" : ""}
          text={t("cartesian.ui.axis_selection.support_axis")}
          onClick={handleSupportAxisChange}
        />
      </div>
      <div className="flex flex-col space-y-5">
        <CheckboxesFiltersSection
          filters={filters}
          handleCoverStripChange={handleCoverStripChange}
          handleAntistaticBeltChange={handleAntistaticBeltChange}
          handleIncreasedCorrosionProtectionChange={handleIncreasedCorrosionProtectionChange}
          isLoadingOrFetchingGetAxesCombinations={isLoadingOrFetchingGetAxesCombinations}
          dependencies={dependencies}
        />
      </div>
    </div>
  );
};

const ProductTypeSection = ({ possibleFiltersValues, filters, onProductTypeChange, dependencies }) => {
  const axisTypes = possibleFiltersValues?.axis?.axisType || [];
  // exclude the 4 first elements for the first version
  const filtredAxisTypes = axisTypes.filter(
    (axisType) =>
      ![
        "CAR axis with toothed belt",
        "CAS axis with toothed belt",
        "MAXH double axis with toothed belt",
        "MAXS double axis with toothed belt"
      ].includes(axisType)
  );

  const midPoint = Math.ceil(filtredAxisTypes.length / 2);
  const firstHalf = filtredAxisTypes.slice(0, filtredAxisTypes.length);
  const secondHalf = filtredAxisTypes.slice(0, 0);

  return (
    <div className="flex flex-col flex-1 space-y-4">
      <span className="font-semibold text-gray-700 mb-2">{t("cartesian.ui.axis_selection.product_ranges")}</span>
      <div className="flex flex-col space-y-5" key={filters?.axisFilters?.axisType}>
        {[firstHalf, secondHalf].map((half) => (
          <div className="flex items-center justify-center space-x-7">
            {half.map((axisType) => {
              return (
                <ProductInfoSection
                  image={productTypeImagesMapping[axisType]}
                  title1={axisType?.split(" ")[0]}
                  title2={axisType?.split(" ").slice(1).join(" ")}
                  value={axisType}
                  isSelected={filters.axisFilter.axisType?.includes(axisType)}
                  handleCheckboxChange={() => {
                    // Create a copy of the current axisType array or initialize it if it's not defined
                    const currentAxisTypes = filters.axisFilter.axisType || [];

                    // Check if the axisType is already included
                    const index = currentAxisTypes.indexOf(axisType);

                    // If it's included, create a new array excluding it; otherwise, add it to the array
                    const newAxisTypes =
                      index >= 0
                        ? [...currentAxisTypes.slice(0, index), ...currentAxisTypes.slice(index + 1)]
                        : [...currentAxisTypes, axisType];

                    // Now, newAxisTypes contains the toggled array of axis types
                    onProductTypeChange(newAxisTypes);
                  }}
                  disabled={!dependencies?.axisType?.includes(axisType)}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

const MiddleSection = ({ possibleFiltersValues, dependencies }) => {
  const dispatch = useDispatch();
  const filters = useSelector(selectCartesianFilters);

  const handleMechanicalDriveChange = (event) => {
    const selectedDriveType = event.target.value;

    const driveTypeArray = selectedDriveType === "" ? undefined : [selectedDriveType];
    // Update the mechanicalDrive property within the filters object
    const updatedAxisFilter = {
      ...filters.axisFilter,
      driveType: driveTypeArray
    };
    // Dispatch the action with the updated filters
    dispatch(
      setCartesianFilters({
        ...filters,
        axisFilter: updatedAxisFilter
      })
    );
  };

  const handleAxisProfileSizeChange = (event) => {
    const selectedAxisProfileSize = event.target.value;
    // Wrap the selectedAxisProfileSize in an array
    const axisProfileSizeArray = selectedAxisProfileSize === "" ? undefined : [selectedAxisProfileSize];
    // Update the axisProfileSize property within the axisProfileFilter object
    const updatedAxisFilter = {
      ...filters.axisFilter,
      profileDimension: axisProfileSizeArray
    };
    // Dispatch the action with the updated filters
    dispatch(
      setCartesianFilters({
        ...filters,
        axisFilter: updatedAxisFilter
      })
    );
  };

  const handleGuideTypeChange = (event) => {
    const selectedGuideType = event.target.value;
    // Wrap the selectedGuideType in an array
    const GuideTypeArray = selectedGuideType === "" ? undefined : [selectedGuideType];
    // Update the GuideType property within the axisProfileFilter object
    const updatedGuideFilter = {
      ...filters.guideFilter,
      guideType: GuideTypeArray
    };
    // Dispatch the action with the updated filters
    dispatch(
      setCartesianFilters({
        ...filters,
        guideFilter: updatedGuideFilter
      })
    );
  };

  return (
    <div className="flex flex-col flex-1 space-y-3">
      <div>
        <div className="mb-2 font-semibold text-gray-700">
          {t("cartesian.ui.axis_selection.mechanical_drive_elements")}
        </div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="mechanicalDrive"
            id="mechanicalDrivers"
            value={filters?.axisFilter?.driveType?.[0] || ""}
            onChange={handleMechanicalDriveChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.all_mechanical_drive")}</option>
            {possibleFiltersValues?.axis?.driveType?.map((mechanicalDriveElt) => {
              const optionDisabled = !dependencies?.driveType?.includes(mechanicalDriveElt);
              return (
                <option
                  className={!optionDisabled && "font-bold"}
                  key={mechanicalDriveElt}
                  value={mechanicalDriveElt}
                  disabled={optionDisabled}
                >
                  {mechanicalDriveElt}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div>
        <div className="mb-2 font-semibold text-gray-700">{t("cartesian.ui.axis_selection.profile_size")}</div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="profileSize"
            id="profileSize"
            value={filters?.axisFilter?.profileDimension?.[0] || ""}
            onChange={handleAxisProfileSizeChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.select_profile_size")}</option>
            {possibleFiltersValues?.axis?.profileDimension
              ?.filter((profileDimensionElt) => profileDimensionElt !== null)
              ?.map((profileDimensionElt) => {
                const optionDisabled = !dependencies?.profileDimension?.includes(profileDimensionElt);
                return (
                  <option
                    className={!optionDisabled && "font-bold"}
                    key={profileDimensionElt}
                    value={profileDimensionElt}
                    disabled={optionDisabled}
                  >
                    {profileDimensionElt}
                  </option>
                );
              })}
          </select>
        </div>
      </div>

      <div>
        <div className="mb-2 font-semibold text-gray-700">{t("cartesian.ui.axis_selection.guide_type")}</div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="guideType"
            id="guideType"
            value={filters?.guideFilter?.guideType?.[0] || ""}
            onChange={handleGuideTypeChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.select_guide_type")}</option>
            {possibleFiltersValues?.guide?.guideType
              ?.filter((guideTypeElt) => guideTypeElt !== null)
              ?.map((guideTypeElt) => {
                const optionDisabled = !dependencies?.guideType?.includes(guideTypeElt);
                return (
                  <option
                    className={!optionDisabled && "font-bold"}
                    key={guideTypeElt}
                    value={guideTypeElt}
                    disabled={optionDisabled}
                  >
                    {guideTypeElt}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>
  );
};

const Scaler = ({ title, leftText, middleText, rightText, isLinear, onChange }) => {
  const [localValue, setLocalValue] = useState({ min: 0, max: 100 });

  const handleMouseUp = () => {
    onChange(localValue);
  };

  const handleChange = (e) => {
    setLocalValue({ ...localValue, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div className="mb-1 font-semibold text-gray-700">{title}</div>
      <div class="w-full">
        <div className="flex flex-col">
          <div
            style={{ background: "transparent", overflow: "initial" }}
            className={` ${isLinear ? "linear-gradient" : "flat-gradient"} flex items-center my-2 drop-shadow`}
          >
            <input
              type="range"
              id="start"
              name="min"
              min="0"
              step="1"
              max="100"
              value={localValue.min}
              onChange={handleChange}
              onMouseUp={handleMouseUp}
            />
            <input
              type="range"
              id="end"
              name="max"
              min="0"
              step="1"
              max="100"
              value={localValue.max}
              onChange={handleChange}
              onMouseUp={handleMouseUp}
            />
          </div>
          <div className="flex text-gray-600">
            <div className="flex-1">{leftText}</div>
            <div className="flex-1 text-center">{middleText}</div>
            <div className="flex-1 text-right">{rightText}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const EndSection = ({ onAxisPerformanceChange }) => (
  <div className="flex flex-col space-y-4 flex-1">
    <Scaler
      title={t("cartesian.ui.axis_selection.axis_performance")}
      leftText={t("cartesian.ui.axis_selection.weak")}
      middleText={t("cartesian.ui.axis_selection.sperfect")}
      rightText={t("cartesian.ui.axis_selection.stoo_big")}
      isLinear
      onChange={onAxisPerformanceChange}
    />
    <Scaler
      title={t("cartesian.ui.axis_selection.price_indicator")}
      leftText="$"
      middleText="$$"
      rightText="$$$"
      isLinear={false}
    />
    <Scaler
      title={t("cartesian.ui.axis_selection.axis_total_length")}
      leftText=""
      middleText=""
      rightText=""
      isLinear={false}
    />
  </div>
);
const CheckboxInput = ({ label, checked, onChange, disabled, isLoading, title }) => {
  return (
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        className={`checked:bg-secondary rounded-sm border-gray-400 checked:border-secondary
        ${isLoading ? "cursor-wait" : disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        checked={checked}
        onChange={onChange}
        disabled={disabled || isLoading}
        title={title}
      />
      <span>{label}</span>
    </div>
  );
};

// section that contains the 3 checkboxes (with cover strip, anti-static belt, increased corrosion protection)
const CheckboxesFiltersSection = ({
  filters,
  handleCoverStripChange,
  handleAntistaticBeltChange,
  handleIncreasedCorrosionProtectionChange,
  isLoadingOrFetchingGetAxesCombinations,
  dependencies
}) => {
  return (
    <div className="flex flex-col flex-1">
      <div className="space-y-1">
        <span className="flex items-center space-x-1 text-gray-600">
          <span className="font-semibold">{t("cartesian.ui.stepper.axisoptionscamel")}</span>
          <MsxIcons name="info" size="nano" />
        </span>
        <CheckboxInput
          label={t("cartesian.ui.axis_selection.with_cover_strip")}
          checked={filters?.applicationDataFilter?.withCoverstrip}
          onChange={handleCoverStripChange}
          disabled={
            dependencies?.withCoverStripSwitchable === false ||
            filters?.applicationDataFilter?.withIncreasedCorrosionProtection
          }
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={dependencies?.withCoverStripSwitchable === false && t("msizer.ui.tooltip.cannot_change_option")}
        />
      </div>

      <div className="space-y-1">
        <CheckboxInput
          label={t("cartesian.ui.axis_selection.antistatic_belt")}
          checked={filters?.applicationDataFilter?.withAntistaticBelt}
          onChange={handleAntistaticBeltChange}
          disabled={dependencies?.withAntistaticBeltSwitchable === false}
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={dependencies?.withAntistaticBeltSwitchable === false && t("msizer.ui.tooltip.cannot_change_option")}
        />
      </div>
      <div className="space-y-1">
        <CheckboxInput
          label={t("cartesian.ui.axis_selection.increased_corrosion_protection")}
          checked={filters?.applicationDataFilter?.withIncreasedCorrosionProtection}
          onChange={handleIncreasedCorrosionProtectionChange}
          disabled={
            dependencies?.withIncreasedCorrosionProtectionSwitchable === false ||
            filters?.applicationDataFilter?.withCoverstrip
          }
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={
            dependencies?.withIncreasedCorrosionProtectionSwitchable === false &&
            t("msizer.ui.tooltip.cannot_change_option")
          }
        />
      </div>
    </div>
  );
};

const FiltersSection = ({
  onClose,
  refetchAxesCombinations,
  dependencies,
  isLoadingDependencies,
  isFetchingDependencies
}) => {
  const dispatch = useDispatch();
  const possibleFiltersValues = useSelector(selectCartesianPossibleFiltersValues);
  const filters = useSelector(selectCartesianFilters);

  // Function to handle changes in the selection
  const handleProductTypeChange = (newProductTypes) => {
    // Check if the new selection is different from the current one
    const isNewSelectionDifferent = JSON.stringify(newProductTypes) !== JSON.stringify(filters.axisFilter.axisType);

    if (isNewSelectionDifferent) {
      // Only update the filters if the new selection is different
      const updatedAxisFilter = {
        ...filters,
        axisFilter: {
          ...filters.axisFilter,
          axisType: newProductTypes?.length > 0 ? newProductTypes : undefined
        }
      };

      dispatch(setCartesianFilters(updatedAxisFilter));
    }
  };

  // const handleAxisPerformanceChange = (newAxisPerformance) => {
  //   console.log(newAxisPerformance);
  //   // setFilters((prevFilters) => ({
  //   //   ...prevFilters,
  //   //   axisPerformanceFilter: newAxisPerformance
  //   // }));
  // };

  const defaultFilters = useSelector(selectDefaultFilters);

  const handleClearFilters = () => {
    dispatch(setCartesianFilters(defaultFilters));
  };

  const handleApplyFilters = () => {
    refetchAxesCombinations();
    onClose();
  };

  return (
    <div className="bg-gray-10 drop-shadow border-l-4 border-l-primary p-3">
      {(isLoadingDependencies || isFetchingDependencies) && (
        <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center">
          <Spinner />
        </div>
      )}
      <div className="flex flex-col space-y-5">
        <div className="flex justify-start">
          <AxisTypeSection
            isLoadingOrFetchingGetAxesCombinations={isLoadingDependencies || isFetchingDependencies}
            filters={filters}
            dependencies={dependencies}
          />
          <ProductTypeSection
            possibleFiltersValues={possibleFiltersValues}
            onProductTypeChange={handleProductTypeChange}
            filters={filters}
            dependencies={dependencies}
          />
          <MiddleSection possibleFiltersValues={possibleFiltersValues} dependencies={dependencies} />
          {/* <EndSection onAxisPerformanceChange={handleAxisPerformanceChange} /> */}
        </div>
        <div className="items-center justify-center flex flex-row space-x-2">
          <qds-button
            onClick={handleApplyFilters}
            importance="emphasized"
            text={t("cartesian.ui.axis_selection.apply-button")}
          />

          <qds-button onClick={handleClearFilters} text={t("cartesian.ui.axis_selection.clear-filters")} />
          {/* <div className="absolute right-4">
            Axes combinations (
            {dependencies?.applicationData?.countOfAxisCombinations !== undefined
              ? dependencies?.applicationData?.countOfAxisCombinations
              : "..."}
            )
          </div> */}
        </div>
      </div>
    </div>
  );
};

const AxisSelectionFilter = ({ refetchAxesCombinations, isLoadingOrFetchingGetAxesCombinations }) => {
  const [filtersOpened, setFiltersOpened] = useState(true);
  const filters = useSelector(selectCartesianFilters);
  const dispatch = useDispatch();

  const [dependencies, setDependencies] = useState(null);

  const {
    refetch: syncDependencies,
    isLoading: isLoadingDependencies,
    isFetching: isFetchingDependencies
  } = useQuery(
    "Get axes combinations",
    async () => {
      try {
        console.log("Sync dependencies");
        setDependencies(null);

        const payload = {
          device: "ALL",
          criteria: {
            locale: "en-WW",
            applicationData: {
              withCoverstrip: filters?.applicationDataFilter?.withCoverstrip
            },
            axis: {
              driveType: filters?.axisFilter?.driveType || null,
              profileDimension: filters?.axisFilter?.profileDimension || null,
              axisType: filters?.axisFilter?.axisType || null
            },
            mechanicalDrive: {
              functionAvailable: filters?.mechanicalDriveFilter?.functionAvailable
            },
            guide: {
              guideType: filters?.guideFilter?.guideType || null,
              functionAvailable: filters?.guideFilter?.functionAvailable
            }
            //,
            // carriage: {
            //   maxVelocity: 0,
            //   maxAcceleration: 0
            // }
          }
        };

        // const result = await syncCartesianFiltersDependencies(payload);
        // console.log("dependencies result", result);

        // to figure out if "with cover strip" is switchable, we should send a request with inversed value
        // and check out if the count of axis combinations is greater than 0
        const payloadForCoverStrip = {
          ...payload,
          criteria: {
            ...payload.criteria,
            applicationData: {
              withCoverstrip: !filters?.applicationDataFilter?.withCoverstrip
            }
          }
        };
        // const resultForCoverStrip = await syncCartesianFiltersDependencies(payloadForCoverStrip);

        // "antistatic belt"
        const payloadForAntistaticBelt = {
          ...payload,
          criteria: {
            ...payload.criteria,
            mechanicalDrive: {
              functionAvailable: payload.criteria.mechanicalDrive.functionAvailable.includes("anti-static toothed belt")
                ? [null, "standard"]
                : ["anti-static toothed belt"]
            }
          }
        };

        // const resultForAntistaticBelt = await syncCartesianFiltersDependencies(payloadForAntistaticBelt);

        // "increased corrosion protection"
        const payloadForIncreasedCorrosionProtection = {
          ...payload,
          criteria: {
            ...payload.criteria,
            guide: {
              functionAvailable: payload.criteria.guide.functionAvailable.includes("increased corrosion resistance")
                ? [null, "standard"]
                : ["increased corrosion resistance"]
            }
          }
        };

        // const resultForIncreasedCorrosionProtection = await syncCartesianFiltersDependencies(
        //   payloadForIncreasedCorrosionProtection
        // );

        const payloadForProductType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              axisType: null
            }
          }
        };

        // Mechanical drive elements (drive type)
        const payloadForDriveType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              driveType: null
            }
          }
        };
        // const resultForDriveType = await syncCartesianFiltersDependencies(payloadForDriveType);

        // Axis profile size (profile dimension)
        const payloadForProfileDimension = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              profileDimension: null
            }
          }
        };
        // const resultForProfileDimension = await syncCartesianFiltersDependencies(payloadForProfileDimension);

        // Guide type
        const payloadForGuideType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            guide: {
              guideType: null
            }
          }
        };
        // const resultForGuideType = await syncCartesianFiltersDependencies(payloadForGuideType);

        // run all dependencies at once
        const [
          result,
          resultForCoverStrip,
          resultForAntistaticBelt,
          resultForIncreasedCorrosionProtection,
          resultForProductType,
          resultForDriveType,
          resultForProfileDimension,
          resultForGuideType
        ] = await Promise.all([
          syncCartesianFiltersDependencies(payload),
          syncCartesianFiltersDependencies(payloadForCoverStrip),
          syncCartesianFiltersDependencies(payloadForAntistaticBelt),
          syncCartesianFiltersDependencies(payloadForIncreasedCorrosionProtection),
          syncCartesianFiltersDependencies(payloadForProductType),
          syncCartesianFiltersDependencies(payloadForDriveType),
          syncCartesianFiltersDependencies(payloadForProfileDimension),
          syncCartesianFiltersDependencies(payloadForGuideType)
        ]);

        setDependencies({
          ...result,
          withCoverStripSwitchable: resultForCoverStrip?.applicationData?.countOfAxisCombinations > 0,
          withAntistaticBeltSwitchable: resultForAntistaticBelt?.applicationData?.countOfAxisCombinations > 0,
          withIncreasedCorrosionProtectionSwitchable:
            resultForIncreasedCorrosionProtection?.applicationData?.countOfAxisCombinations > 0,
          axisType: resultForProductType?.axis?.axisType,
          driveType: resultForDriveType?.axis?.driveType,
          profileDimension: resultForProfileDimension?.axis?.profileDimension,
          guideType: resultForGuideType?.guide?.guideType
        });
        console.log("dependencies", dependencies);
        return result;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    async function fetchData() {
      try {
        await syncDependencies();
        //await refetchAxesCombinations();
      } catch (error) {
        console.error("Error executing functions:", error);
      }
    }
    fetchData();
  }, [filters]);

  const dynamics = useSelector(selectDynamics);
  const mechanics = useSelector(selectMechanics);

  // get maximum value found for Input_Peak_velocity (dynamics step)
  //const maxPeakVelocity = Math.max(...dynamics.steps?.map((step) => step.peak));
  // get maximum value found for Input_Peak_Acceleration (Dynamics step)
  //const maxPeakAcceleration = Math.max(...dynamics.steps?.map((step) => step.aacc));
  // get Input_Stroke_Length (Mechanics step)
  //const strokeLength = mechanics.strokeLength;
  // TODO Ballscrew related CRs (ballscrew axes only)

  return (
    <div className="mt-20 flex flex-col space-y-4 text-sm select-none">
      <div className="flex">
        <FiltersButton
          filtersOpened={filtersOpened}
          isLoadingOrFetchingGetAxesCombinations={isLoadingOrFetchingGetAxesCombinations}
          onClick={() => {
            if (!isLoadingOrFetchingGetAxesCombinations) setFiltersOpened(!filtersOpened);
          }}
        />
      </div>
      {filtersOpened && (
        <FiltersSection
          dependencies={dependencies}
          isLoadingDependencies={isLoadingDependencies}
          isFetchingDependencies={isFetchingDependencies}
          onClose={() => {
            //setFiltersOpened(false);
          }}
          refetchAxesCombinations={refetchAxesCombinations}
        />
      )}
    </div>
  );
};
export default AxisSelectionFilter;
